// --- Buy Now ---
document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  const buyNowBtn = event.target.closest('[data-buy-now]');
  if (!buyNowBtn) return;
  event.preventDefault();

  const variantId = Number(buyNowBtn.getAttribute('data-variant-id') || '0');
  const quantitySelector = buyNowBtn.getAttribute('data-quantity-input-selector');
  const quantityInput = quantitySelector ? document.querySelector(quantitySelector) : null;
  const quantity = Math.max(
    1,
    Number(
      quantityInput instanceof HTMLInputElement
        ? quantityInput.value
        : buyNowBtn.getAttribute('data-quantity') || '1'
    )
  );

  if (!variantId) {
    const fallbackHref = buyNowBtn.getAttribute('href');
    window.location.href = fallbackHref || '/checkout';
    return;
  }

  buyNowBtn.setAttribute('aria-busy', 'true');

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify({ id: variantId, quantity: quantity })
  })
    .then((res) => {
      if (!res.ok) throw new Error('Failed to add variant for Buy Now');
      return res.json();
    })
    .then(() => {
      window.location.href = '/checkout';
    })
    .catch(() => {
      // Fallback permalink keeps Buy Now functional even if AJAX add fails.
      window.location.href = `/cart/${variantId}:${quantity}?checkout`;
    })
    .finally(() => {
      buyNowBtn.removeAttribute('aria-busy');
    });
});

// --- Add to Cart ---
document.addEventListener('click', async (event) => {
  if (!(event.target instanceof Element)) return;
  const atcBtn = event.target.closest('[data-add-to-cart-card]');
  if (!atcBtn) return;
  event.preventDefault();

  if (atcBtn.classList.contains('in-cart')) {
    return;
  }

  if (atcBtn.getAttribute('data-atc-processing') === 'true') return;

  const variantId = Number(atcBtn.getAttribute('data-variant-id') || '0');
  const quantity = Math.max(1, Number(atcBtn.getAttribute('data-quantity') || '1'));
  if (!variantId) return;

  const btn = atcBtn instanceof HTMLButtonElement ? atcBtn : null;
  const originalText = atcBtn.textContent;
  atcBtn.setAttribute('data-atc-processing', 'true');
  if (btn) btn.disabled = true;
  atcBtn.textContent = 'Adding...';

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ id: variantId, quantity })
    });
    if (!response.ok) throw new Error('Failed to add to cart');

    const cart = await getCart();
    updateCartBadge(cart.item_count);
    document.dispatchEvent(new CustomEvent('cart:update', {
      detail: { data: { itemCount: cart.item_count } }
    }));

    document.querySelectorAll('[data-add-to-cart-card]').forEach(function(cardBtn) {
      var vId = Number(cardBtn.getAttribute('data-variant-id'));
      var inCart = false;
      if (cart.items && Array.isArray(cart.items)) {
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i] && cart.items[i].variant_id === vId) {
            inCart = true;
            break;
          }
        }
      }
      setButtonState(cardBtn, inCart);
    });
    setButtonState(atcBtn, true);
  } catch (err) {
    console.error('[Add to Cart]', err);
    atcBtn.textContent = originalText;
    atcBtn.removeAttribute('data-atc-processing');
    if (btn) btn.disabled = false;
  }
  atcBtn.removeAttribute('data-atc-processing');
  if (btn) btn.disabled = false;
});

// --- Add to Cart Animation, Badge, and State ---
// Assumes: cart icon has id="cart-icon" and badge span id="cart-badge"
// Each product card/button must have data-variant-id

/** @param {Element} btn */
function animateToCart(btn) {
  var cartIcon = document.getElementById('cart-icon');
  if (!cartIcon) return;
  if (!btn || typeof btn.getBoundingClientRect !== 'function') return;
  var rectBtn = btn.getBoundingClientRect();
  var rectCart = cartIcon.getBoundingClientRect();
  var sparkle = document.createElement('div');
  sparkle.className = 'cart-sparkle';
  document.body.appendChild(sparkle);
  sparkle.style.left = rectBtn.left + rectBtn.width / 2 + 'px';
  sparkle.style.top = rectBtn.top + rectBtn.height / 2 + 'px';
  sparkle.style.opacity = '1';
  sparkle.style.transform = 'scale(1)';
  requestAnimationFrame(function() {
    sparkle.style.transition = 'all 0.7s cubic-bezier(.4,2,.6,1)';
    sparkle.style.left = rectCart.left + rectCart.width / 2 + 'px';
    sparkle.style.top = rectCart.top + rectCart.height / 2 + 'px';
    sparkle.style.opacity = '0';
    sparkle.style.transform = 'scale(0.3)';
  });
  setTimeout(function() { sparkle.remove(); }, 800);
}

/** @param {number} count */
function updateCartBadge(count) {
  var badge = document.getElementById('cart-badge');
  if (badge) badge.textContent = count > 0 ? String(count) : '';
}

/** @param {Element} btn @param {boolean} inCart */
function setButtonState(btn, inCart) {
  if (!btn) return;
  if (inCart) {
    btn.textContent = 'Added';
    btn.classList.add('in-cart');
  } else {
    btn.textContent = 'Add to Cart';
    btn.classList.remove('in-cart');
  }
}

async function getCart() {
  var res = await fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
  if (!res.ok) return { items: [], item_count: 0 };
  return res.json();
}

/** @param {number} variantId @param {number} quantity */
async function addToCart(variantId, quantity) {
  var res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: quantity })
  });
  return res.ok;
}

// --- Main handler ---
document.addEventListener('DOMContentLoaded', async () => {
  const btns = document.querySelectorAll('[data-add-to-cart-card], [data-add-to-cart-animated]');
  const cart = await getCart();
  updateCartBadge(cart.item_count);
  btns.forEach(function(btn) {
    var variantId = Number(btn.getAttribute('data-variant-id'));
    var inCart = false;
    if (cart.items && Array.isArray(cart.items)) {
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i] && cart.items[i].variant_id === variantId) {
          inCart = true;
          break;
        }
      }
    }
    setButtonState(btn, inCart);
    if (btn.hasAttribute('data-add-to-cart-animated')) {
      btn.addEventListener('click', async function() {
        if (btn.classList.contains('in-cart')) {
          return;
        }
        if ('disabled' in btn) btn.disabled = true;
        animateToCart(btn);
        var ok = await addToCart(variantId, 1);
        var updatedCart = await getCart();
        updateCartBadge(updatedCart.item_count);
        setButtonState(btn, ok);
        if ('disabled' in btn) btn.disabled = false;
      });
    }
  });
});

// --- CSS (inject if not present) ---
(function() {
  if (document.getElementById('cart-sparkle-style')) return;
  const style = document.createElement('style');
  style.id = 'cart-sparkle-style';
  style.textContent = `
    .cart-sparkle {
      position: fixed; z-index: 9999; width: 16px; height: 16px;
      pointer-events: none; border-radius: 50%;
      background: radial-gradient(circle, #ffd700 60%, #fff 100%);
      box-shadow: 0 0 8px 2px #ffd70099;
      transition: all 0.7s cubic-bezier(.4,2,.6,1);
      opacity: 0;
    }
    [data-add-to-cart-card].in-cart,
    [data-add-to-cart-animated].in-cart {
      background: #e20d18 !important;
      border-color: #e20d18 !important;
      color: #fff !important;
      opacity: 1 !important;
      filter: none !important;
      cursor: default;
    }

    [data-add-to-cart-card].in-cart:hover,
    [data-add-to-cart-animated].in-cart:hover,
    [data-add-to-cart-card].in-cart:focus-visible,
    [data-add-to-cart-animated].in-cart:focus-visible {
      background: #c90b14 !important;
      border-color: #c90b14 !important;
      color: #fff !important;
      opacity: 1 !important;
    }
  `;
  document.head.appendChild(style);
})();
